<fieldset class="is-flex is-flex-direction-column is-gap-4">
  <div>
    <h3>{{ 'tarificateur.hospitalisation' | translate }}</h3>
    <p>
      {{ 'tarificateur.hospitalisation.subtitle' | translate }}
    </p>
  </div>
  <mat-radio-group
    [formControl]="fc"
    attr.aria-label="{{ 'tarificateur.hospitalisation' | translate }}"
    name="evacsanitaire"
    class="is-flex is-flex-direction-column gap-s">
    <mat-radio-button value="Bronze" class="tarif-option desktop-pb-2">
      <b class="is-size-6">Bronze</b>
      <p>{{ 'tarificateur.hospitalisation.plafond' | translate }}</p>
      {{ '500000' | currencyFormat }}
    </mat-radio-button>
    <mat-radio-button value="Silver" class="tarif-option desktop-pb-2">
      <b class="is-size-6">Silver</b>
      <p>{{ 'tarificateur.hospitalisation.plafond' | translate }}</p>
      {{ '1000000' | currencyFormat }}
    </mat-radio-button>
    <mat-radio-button value="Gold" class="tarif-option desktop-pb-2">
      <b class="is-size-6">Gold</b>
      <p>{{ 'tarificateur.hospitalisation.plafond' | translate }}</p>
      {{ '2000000' | currencyFormat }}
    </mat-radio-button>
    <mat-radio-button value="Platinum" class="tarif-option desktop-pb-2">
      <b class="is-size-6">Platinum</b>
      <p>{{ 'tarificateur.hospitalisation.plafond' | translate }}</p>
      {{ '3000000' | currencyFormat }}
    </mat-radio-button>
  </mat-radio-group>
  <acs-guarantees-table></acs-guarantees-table>
</fieldset>
